/* eslint-disable */

import React from "react";
import { createScope, map, transformProxies } from "./helpers";
import SiteHeader from "../../components/SiteHeader";
import SiteFooter from "../../components/SiteFooter";

const scripts = [
  {
    loading: fetch(
      "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=61e48a462079c356c6452042"
    ).then((body) => body.text()),
    isAsync: false,
  },
  {
    loading: fetch("js/webflow.js").then((body) => body.text()),
    isAsync: false,
  },
];

let Controller;

class NotFoundView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require("../NotFound");
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == "MODULE_NOT_FOUND") {
        Controller = NotFoundView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector("html");
    htmlEl.dataset["wfPage"] = "6242288191da2b2370937896";
    htmlEl.dataset["wfSite"] = "61e48a462079c356c6452042";

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script);

          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      NotFoundView.Controller !== NotFoundView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/custom.webflow.css);
        `,
          }}
        />
        <span className="af-view">
          <div>
            <SiteHeader />
            <section className="af-class-utility-page-wrap">
              <div className="af-class-utility-page-content-404 w-form">
                <div className="af-class-text-center af-class-color-white">
                  <div className="af-class-_404-title animate-xappear">
                    Not here!
                  </div>
                  <h2
                    data-w-id="5e86adabd2a28d2afbf80eae00000000000d"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      opacity: 0,
                    }}
                    className="af-class-color-white"
                  >
                    Page Not Found
                  </h2>
                  <p
                    data-w-id="Paragraph"
                    style={{
                      WebkitTransform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform:
                        "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      opacity: 0,
                    }}
                    className="af-class-paragraph af-class-_404"
                  >
                    Sorry, this page does not exist. Feel free to come back to
                    our home page, and contact us if you have any question!
                  </p>
                  <div className="af-class-mg-top-24px">
                    <a
                      data-w-id="e3481f6c-0f69-b413-cfd7-e6ac4c0ca6d1"
                      style={{
                        WebkitTransform:
                          "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        MozTransform:
                          "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        msTransform:
                          "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        transform:
                          "translate3d(0, 0, 0) scale3d(0.97, 0.97, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        opacity: 0,
                      }}
                      href="index.html"
                      className="af-class-button-primary af-class-buttononblack af-class-mg-left-72px w-inline-block"
                    >
                      <div>
                        Go to homepage
                        <span className="af-class-button-arrow"></span>
                      </div>
                      <div className="af-class-underline-wrap">
                        <div className="af-class-button-underline" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>
            <SiteFooter />
            {/* [if lte IE 9]><![endif] */}
          </div>
        </span>
      </span>
    );
  }
}

export default NotFoundView;

/* eslint-enable */
